import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _get from 'lodash/get';
import PropTypes from 'prop-types';
// Core components
import TextField from 'components/core/TextField';
import { ContainedButton } from 'components/core/Button';
import Card from 'components/core/Card';
// HOCS
import withFormManagement from 'hocs/WithFormManagement';
// Models
import { sanitizeDesc } from 'models/accessWay';
// Custom
import { buildFormErrors, cpmOnDemandAccessLicensePlateConstraints } from 'utils/Forms';
import { navigateToContactUs } from 'cpmMore/navigation';

class CheckoutLicensePlate extends React.Component {
  constructor(props) {
    super(props);

    this.handleValidate = this.handleValidate.bind(this);
  }

  componentDidMount() {
    const { fields: { licensePlate }, onValidate } = this.props;

    // Validate form immediately if license plate is set on component mount
    const errors = buildFormErrors(
      { licensePlate },
      cpmOnDemandAccessLicensePlateConstraints,
    );

    if (!errors) {
      onValidate({ licensePlate });
    }
  }

  // Handlers
  handleValidate() {
    const {
      fields: { licensePlate },
      onErrorsChange,
      onValidate,
    } = this.props;
    const errors = buildFormErrors({ licensePlate }, cpmOnDemandAccessLicensePlateConstraints);
    // Apply errors
    onErrorsChange(errors);

    // No error => validate form
    if (!errors) {
      onValidate({ licensePlate });
    }
  }

  render() {
    const {
      fields: { licensePlate },
      errors,
      globalErrors,
      onFieldsChange,
    } = this.props;

    return (
      <Card>
        <div className="row">
          <div className="col-12 text-center checkoutCardTitle">
            <LocalizedMessage id="info.checkoutLicensePlate" />
          </div>
          <div className="col-12">
            <TextField
              label={<LocalizedMessage id="field.licensePlate" />}
              required
              value={licensePlate}
              onChange={(value) => onFieldsChange({
                licensePlate: sanitizeDesc(value, 'license_plate'),
              })}
              errorText={_get(errors, 'licensePlate')}
            />
          </div>

          <div className="col-12 text-center pt-3">
            <ContainedButton label={<LocalizedMessage id="button.validate" />} onClick={this.handleValidate} />
          </div>

          {globalErrors && (
            <div className="col-12 text-center my-3 checkoutCardBody">
              <LocalizedMessage id="info.checkoutLicensePlate.tryAgain" />
            </div>
          )}
        </div>

        {/* Button contact */}
        {globalErrors && (
          <div className="row" style={{ marginTop: 30 }}>
            <div className="col-12 text-center">
              <ContainedButton label={<LocalizedMessage id="button.contactUs" />} color="secondary" onClick={navigateToContactUs} />
            </div>
            <div className="col-12 text-center my-3 checkoutCardBody">
              <LocalizedMessage id="info.checkoutLicensePlate.contactUs" />
            </div>
          </div>
        )}
      </Card>
    );
  }
}

CheckoutLicensePlate.propTypes = {
  defaultLicensePlate: PropTypes.string, // eslint-disable-line react/no-unused-prop-types
  fields: PropTypes.object.isRequired,
  errors: PropTypes.object,
  globalErrors: PropTypes.object,
  onFieldsChange: PropTypes.func.isRequired,
  onErrorsChange: PropTypes.func.isRequired,
  onValidate: PropTypes.func.isRequired,
};

CheckoutLicensePlate.defaultProps = {
  defaultLicensePlate: null,
  errors: null,
  globalErrors: null,
};

const mapFieldsToProps = {
  licensePlate: {
    defaultValue: '',
    resourceKey: 'defaultLicensePlate',
  },
};

const mapOwnPropsToResources = (ownProps) => ({
  resourceData: { defaultLicensePlate: ownProps.defaultLicensePlate },
});

module.exports = withFormManagement(
  mapFieldsToProps,
  mapOwnPropsToResources,
  false,
)(CheckoutLicensePlate);



// WEBPACK FOOTER //
// ./routes/checkout/components/CheckoutLicensePlate.js